"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Greeting } from "@/components/greeting";

/**
 * Home logo. When clicked while already on `/`, this is a no-op
 * for the page itself — we scroll to the top instead of letting
 * Next.js remount the homepage (which would replay the boot
 * sequence + the preset `whoami` / `ls` commands). On other pages
 * it navigates to `/` like a normal link.
 */
export function NavLogo() {
  const pathname = usePathname();
  const onHome = pathname === "/";

  return (
    <Link
      href="/"
      onClick={(e) => {
        if (onHome) {
          // Already on the homepage — scroll to the top instead of
          // triggering a soft navigation that would re-run the boot
          // sequence and replay the preset commands.
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }}
      className="font-mono text-sm text-[color:var(--color-muted)] hover:text-[color:var(--color-accent)] transition-colors"
    >
      byemily.org
      {/* Greeting + clock only where there's room next to the links. */}
      <span className="hidden sm:inline">
        <span className="text-[color:var(--color-border)] mx-2">|</span>
        <span className="text-[color:var(--color-accent)]">$</span>{" "}
        <Greeting />
      </span>
    </Link>
  );
}